export default __webpack_public_path__ + "static/googleContactLogo-8a0211e7d2aeb6e3997b65b8d4fc5b2e.svg";